class InitialPackageType {
  None() {
    return "None";
  }
  Secretary() {
    return "Secretary";
  }
  IVR() {
    return "IVR";
  }
  Fax() {
    return "Fax";
  }
  Line() {
    return "Line";
  }
}
export default new InitialPackageType();
